import React, { Suspense, lazy } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, Redirect, Route } from 'react-router-dom'
import { push } from 'connected-react-router'
import { common } from '@ocean/ui'
import { EnvironmentUtils, UserUtils } from 'utils'
import { redirectToSta } from 'core/staIntegration/slices/staIntegration'
import { AccountTypes } from 'modules/Auth/types'
import simulatorTrainingInstructorILSimulatorListRoutes from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const Home = lazy(() => import(/* webpackChunkName: "Home" */ 'modules/Home/pages/Home'))

const HomeRouting = () => {
  const dispatch = useDispatch()
  const { type } = UserUtils.getUserAccountInfo()

  const { simulatorDashboardForAdministratorsAvailable } =
    EnvironmentUtils.getPermissions('simulatorTraining')

  React.useEffect(() => {
    if (type === AccountTypes.SpecialUser) {
      if (simulatorDashboardForAdministratorsAvailable) {
        dispatch(push(simulatorTrainingInstructorILSimulatorListRoutes.root))
      } else {
        dispatch(redirectToSta())
      }
    }
  }, [dispatch, simulatorDashboardForAdministratorsAvailable, type])

  if (type === AccountTypes.SpecialUser) return null
  return (
    <Suspense fallback={<RouteChangeProgress />}>
      <Switch>
        <Route exact path={routes.root} component={Home} />
        <Redirect path='*' to={routes.root} />
      </Switch>
    </Suspense>
  )
}

export default HomeRouting
